import { useQuery } from '@tanstack/react-query'
import { ApiError } from '@/api/request'
import { ticketsApi, type TicketCounts } from '@/api/ticketsApi'

export const TICKET_COUNTS_KEY = ['ticket-counts'] as const

/**
 * Sidebar queue counts. A 404 (endpoint not shipped yet) resolves to `null` so
 * the sidebar simply shows no numbers; anything else surfaces as an error.
 */
export function useTicketCounts() {
  return useQuery<TicketCounts | null>({
    queryKey: TICKET_COUNTS_KEY,
    queryFn: async () => {
      try {
        return await ticketsApi.counts()
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) return null
        throw err
      }
    },
    staleTime: 30_000,
  })
}
